// @ts-nocheck
import React from 'react';

interface AdminConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: 'danger' | 'warning' | 'info';
}

export const AdminConfirmDialog: React.FC<AdminConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'danger',
}) => {
  if (!isOpen) return null;

  const variantStyles = {
    danger: 'bg-red-500 hover:bg-red-600',
    warning: 'bg-orange-500 hover:bg-orange-600',
    info: 'bg-blue-500 hover:bg-blue-600',
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-message"
    >
      <div className="bg-white dark:bg-luna-primary rounded-xl border-2 border-luna-secondary/30 p-6 max-w-md w-full shadow-xl max-h-[90vh] overflow-y-auto">
        <h3 id="confirm-dialog-title" className="text-xl font-bold text-luna-text-light dark:text-luna-text-dark mb-2">
          {title}
        </h3>
        <p id="confirm-dialog-message" className="text-luna-text-light/70 dark:text-luna-text-dark/70 mb-6">
          {message}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-end">
          <button
            onClick={onCancel}
            className="w-full sm:w-auto px-6 py-3 rounded-lg border border-luna-secondary/30 bg-white dark:bg-luna-primary text-luna-text-light dark:text-luna-text-dark hover:bg-luna-secondary/10 transition-colors min-h-[44px] touch-manipulation"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`w-full sm:w-auto px-6 py-3 rounded-lg text-white transition-colors min-h-[44px] touch-manipulation ${variantStyles[variant]}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

